import { PayloadAction } from "@reduxjs/toolkit";
import {
  LoanIntentPurposeEnum,
  SessionInfoResponse,
} from "../../../../orchestrator-api-client";
import { LoanState } from "../loan.slice.ts";

export default function initStoreReducer(
  state: LoanState,
  action: PayloadAction<SessionInfoResponse | undefined>,
) {
  if (action.payload) {
    state.workflowId =
      action.payload.loan?.childWorkflowId ??
      action.payload.loan?.workflowId ??
      "";
    state.channel = action.payload.loan?.channel ?? "";
    state.contactId = action.payload.loan?.contactId ?? "";
    state.positionId = action.payload.loan?.positionId ?? "";
    state.coupon = action.payload.loan?.couponCode ?? "";
    if (action.payload.loan?.purpose) {
      state.loanIntent = {
        ...state.loanIntent,
        purpose: (action.payload.loan.purpose as LoanIntentPurposeEnum) ?? "",
      };
    }
  }
}
